
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.611 4.502c.356 0 .406.005.446.013a.6.6 0 01.173.065c.035.02.076.05.343.285L9.726 5.88l.045.04c.206.181.403.355.633.482a2.4 2.4 0 00.646.244c.258.057.52.057.794.056H16.3c.855 0 1.442 0 1.897.038.445.036.684.103.856.191a2.1 2.1 0 01.918.918c.088.173.155.412.191.856.037.455.038 1.042.038 1.897v3.4c0 .855 0 1.442-.038 1.897-.036.445-.103.684-.19.857a2.1 2.1 0 01-.919.917c-.172.088-.411.155-.856.191-.455.037-1.042.038-1.897.038h-1.997a.9.9 0 000 1.8h2.035c.808 0 1.469 0 2.006-.044.556-.045 1.058-.142 1.526-.38a3.9 3.9 0 001.705-1.705c.239-.47.336-.971.381-1.527.044-.537.044-1.198.044-2.006v-3.475c0-.809 0-1.47-.044-2.006-.045-.556-.142-1.058-.381-1.527a3.9 3.9 0 00-1.704-1.705c-.47-.239-.971-.336-1.527-.38-.537-.045-1.198-.045-2.006-.045h-4.432c-.374 0-.427-.005-.469-.014a.6.6 0 01-.161-.06c-.038-.021-.08-.053-.361-.3L9.762 3.514l-.044-.039c-.195-.172-.382-.337-.6-.46a2.4 2.4 0 00-.694-.262c-.245-.051-.494-.051-.755-.05h-.094c-.767 0-1.395 0-1.907.039-.528.041-1.007.129-1.457.345a3.9 3.9 0 00-1.826 1.826c-.217.45-.304.929-.345 1.458C2 6.88 2 7.51 2 8.278v5.327a.9.9 0 101.8 0V8.313c0-.812 0-1.37.034-1.803.033-.423.094-.652.173-.817a2.1 2.1 0 01.983-.984c.166-.08.395-.14.818-.172.433-.034.99-.035 1.803-.035zm-4.71 11.8a.9.9 0 000 1.8h6.022l-1.659 1.66a.9.9 0 001.273 1.272l3.196-3.195a.9.9 0 000-1.272l-3.191-3.2a.9.9 0 10-1.274 1.27l1.66 1.665H2.9z","fill":"currentColor"}})])
          )
        }
      }
    